import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { FaPhoneAlt, FaCalendarCheck } from 'react-icons/fa';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import Classes from './SiteLayout.module.css';
import { SITE } from '../../../data/siteConfig';

// Scroll to top on route change, or to the #section when the URL has a hash.
function ScrollManager() {
    const { pathname, hash, state } = useLocation();
    useEffect(() => {
        if (hash) {
            // Wait a tick so the target page has rendered.
            const t = setTimeout(() => {
                document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: 'smooth' });
            }, 50);
            return () => clearTimeout(t);
        }
        window.scrollTo({ top: 0, behavior: state?.smoothTop ? 'smooth' : 'auto' });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathname, hash]);
    return null;
}

export default function SiteLayout() {
    return (
        <>
            <ScrollManager />
            <Header />
            <Outlet />
            <Footer />

            {/* Sticky mobile call / book bar */}
            <div className={Classes.mobileBar}>
                <a href={`tel:${SITE.phoneE164}`} className="btn btn-outline"><FaPhoneAlt /> Call Now</a>
                <a href={SITE.bookingUrl} target="_blank" rel="noopener noreferrer" className="btn btn-dark"><FaCalendarCheck /> Book Online</a>
            </div>
        </>
    );
}
